import { Box, Link } from "@mui/material";
import { AuthConsumer } from "../../providers/authProvider";

export const Callback = () => (
  <AuthConsumer>
    {({ signinRedirectCallback }) => {
       signinRedirectCallback();

      return (
        <Box display='flex' flex="column" height="100vh" alignItems='center' justifyContent='center'>
          <span>
            If the site does not refresh in 15 seconds, please click <Link onClick={signinRedirectCallback()}> here</Link>
          </span>
            
        </Box>
      );
    }}
  </AuthConsumer>
);
